module.exports = __webpack_public_path__ + "img/receive1.23b95411.png";